import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CalendarEvent } from '../../models';
import 'add-to-calendar-button';
import moment from 'moment';

@Component({
    selector: 'lib-export-calendar-dialog',
    templateUrl: './export-calendar-dialog.component.html',
    styleUrls: ['./export-calendar-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExportCalendarDialogComponent implements OnInit {
  public exportOptions: string;
  public eventDates: { startDate: string, startTime: string, endDate: string, endTime: string };
  public icsUrl: string;

  public EXPORT_TO = ['Google', 'iCal', 'Microsoft365'];

  constructor(@Inject(MAT_DIALOG_DATA) public event: CalendarEvent) { }

  ngOnInit(): void {
    const { date, duration, location } = this.event;

    this.eventDates = date && this.getEventDates(date, duration);
    this.exportOptions = this.EXPORT_TO.map(item => `'${item}'`).join(',')
    this.icsUrl = this.extractSoleUrl(location);
  }

  private extractSoleUrl(html?: string): string {
    if (!html) {
      return '';
    }

    const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
    const textContent = parsedHtml.body.textContent?.trim() ?? '';

    return this.isUrl(textContent) ? textContent : '';
  }

  private isUrl(value: string): boolean {
    if (!value) {
      return false;
    }

    try {
      new URL(value);
      return true;
    } catch {
      return false;
    }
  }

  private getEventDates(date: Date | string, durationInMinutes: number): any {
    const start = moment(date).utc(false);
    const end = moment(date).utc(false).add(durationInMinutes, 'minutes');

    return {
      startDate: start.format('YYYY-MM-DD'),
      startTime: start.format('HH:mm'),
      endDate: end.format('YYYY-MM-DD'),
      endTime: end.format('HH:mm')
    };
  }
}
